var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShape19 = function SvgShape19(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 102,
    height: 92,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.947 23.385c0-.792 0-1.187.01-1.522C1.312 10.467 10.468 1.31 21.864.958c.334-.01.73-.01 1.522-.01 4.222 0 6.334 0 8.119.055C92.28 2.889 141.11 51.719 142.997 112.496c.056 1.785.056 3.897.056 8.119 0 .792 0 1.188-.011 1.522-.354 11.396-9.509 20.552-20.905 20.905-.335.011-.73.011-1.522.011H32.893c-9.652 0-14.478 0-18.307-1.516a21.59 21.59 0 0 1-12.123-12.123C.947 125.585.947 120.759.947 111.107z",
    opacity: 0.1
  })));
};
export default SvgShape19;